'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Button } from '@workspace/ui/components/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@workspace/ui/components/dialog';
import Image from 'next/image';
import Link from 'next/link';
import { useCallback, useEffect, useState } from 'react';

const DISMISSED_STORAGE_KEY_PREFIX = 'salary_wallet_active_popup_dismissed_';

function hasDismissedPopup(userId: number): boolean {
  try {
    return localStorage.getItem(`${DISMISSED_STORAGE_KEY_PREFIX}${userId}`) === 'true';
  } catch {
    return false;
  }
}

function markPopupDismissed(userId: number): void {
  try {
    localStorage.setItem(`${DISMISSED_STORAGE_KEY_PREFIX}${userId}`, 'true');
  } catch {
    // Ignore storage errors (e.g. private browsing / storage disabled)
  }
}

interface SalaryWalletActiveDialogProps {
  userId?: number;
  /** Whether the current user is eligible for the salary wallet feature. */
  canAccessSalaryWallet: boolean;
}

/**
 * One-time announcement dialog shown on the wallet home page to users who are eligible
 * for the salary wallet feature. Dismissal (via close, "Check it later", or "See more")
 * is persisted per-user in localStorage so it never shows again on this device.
 */
export function SalaryWalletActiveDialog({
  userId,
  canAccessSalaryWallet,
}: SalaryWalletActiveDialogProps) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!canAccessSalaryWallet || !userId) return;
    if (hasDismissedPopup(userId)) return;

    setIsOpen(true);
  }, [canAccessSalaryWallet, userId]);

  const handleOpenChange = useCallback(
    (open: boolean) => {
      setIsOpen(open);
      if (!open && userId) {
        markPopupDismissed(userId);
      }
    },
    [userId]
  );

  if (!canAccessSalaryWallet) return null;

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent size="md" onOpenAutoFocus={(e) => e.preventDefault()}>
        <div className="flex w-full flex-col gap-7">
          <DialogHeader>
            <DialogTitle>Your salary wallet is now active</DialogTitle>
          </DialogHeader>

          <Image
            src="https://i.nativeteams.com/assets/app/wallet/salary-wallet/salary-wallet-active-illustration.webp"
            alt=""
            width={512}
            height={228}
            className="h-auto w-full rounded-2xl"
          />

          <DialogDescription className="whitespace-pre-line text-sm leading-5 text-grey-800">
            {
              'Your first salary has been received.\nExplore your salary wallet and calculate your potential rewards in one place.'
            }
          </DialogDescription>

          <DialogFooter>
            <Button variant="primary" className="w-full" asChild>
              <Link
                href="/salary-wallet"
                onClick={() => {
                  if (userId) markPopupDismissed(userId);
                }}
              >
                See more
              </Link>
            </Button>
            <DialogClose asChild>
              <Button variant="secondary" className="w-full">
                Check it later
              </Button>
            </DialogClose>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
